import CardSquare from '@/common/components/cardSquare/CardSquare';
import { Link } from 'react-router-dom';
import StatusLogIcon from '@/common/assets/icons/statusLog.svg?react';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { StatusLogCardProps } from '@/modules/FileDetail/components/entryTabs/Cards/StatusLogCard/StatusLogCard.types.ts';
import { token } from 'styled-system/tokens';

const StatusLogCard = ({ title }: StatusLogCardProps) => {
  return (
    <Link to={FILE_DETAIL_LINKS.statusTransition}>
      <CardSquare
        title={title}
        renderIcon={() => <StatusLogIcon color={token('colors.purple-1')} />}
      />
    </Link>
  );
};
export default StatusLogCard;
